<ion-tabs>
  <ion-tab-bar slot="bottom" color="dark">
    <ion-tab-button tab="feed">
      <ion-icon name="home"></ion-icon>
      <ion-label>Home</ion-label>
    </ion-tab-button>

    <ion-tab-button tab="wallet">
      <ion-icon name="wallet"></ion-icon>
      <ion-label>Carteira</ion-label>
    </ion-tab-button>

    <ion-tab-button tab="settings">
      <ion-icon name="cog"></ion-icon>
      <ion-label>Ajustes</ion-label>
    </ion-tab-button>
  </ion-tab-bar>
</ion-tabs>
